import { SET_ELCCONTROLLERS } from '../constants/ELCControllerConstants';

const initialState = {
  elcControllers: {
    list: [],
    count: 0,
  },
  updated: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_ELCCONTROLLERS: {
      return {
        ...state,
        elcControllers: action.payload,
        updated: false,
      };
    }

    default:
      return state;
  }
}
